import { useAllInterestPerLangQuery } from '@src/Api/Graphql/gql/types.generated';
import {useCurrentLanguage} from '~Store/Slices/LanguageSlice/Language.selector';

interface InterestTagsItem {
  name: string;
  id: string;
}

interface InterestTags {
  fr: InterestTagsItem[];
  en: InterestTagsItem[];
  pt: InterestTagsItem[];
}
const tagLanguage: Record<string, keyof InterestTags> = {
  'en-US': 'en',
  fr: 'fr',
  'pt-BR': 'pt',
};

const useInterestTags = () => {
  const {data, loading} = useAllInterestPerLangQuery({
    fetchPolicy: 'no-cache',
  });
  const currentLanguage = useCurrentLanguage();
  const tagLang = tagLanguage[currentLanguage];

  const interestTags: InterestTags = {
    fr:
      data?.frTag?.children?.items?.map(item => ({
        name: item?.name || '',
        id: item?.id || '',
      })) || [],
    en:
      data?.enTag?.children?.items?.map(item => ({
        name: item?.name || '',
        id: item?.id || '',
      })) || [],
    pt:
      data?.ptTag?.children?.items?.map(item => ({
        name: item?.name || '',
        id: item?.id || '',
      })) || [],
  };

  const findTagItem = (tag: string) => {
    let tagItem: InterestTagsItem | undefined;
    const tagInFr = interestTags.fr.find(
      item => item.name === tag || item.id === tag,
    );
    if (tagInFr) tagItem = tagInFr;

    const tagInEn = interestTags.en.find(
      item => item.name === tag || item.id === tag,
    );
    if (tagInEn) tagItem = tagInEn;

    const tagInPt = interestTags.pt.find(
      item => item.name === tag || item.id === tag,
    );
    if (tagInPt) tagItem = tagInPt;

    if (tagItem) {
      return tagLang
        ? interestTags[tagLang]?.find(item => item.id === tagItem.id) || tagItem
        : tagItem;
    }
    return null;
  };

  return {
    interestTags: tagLang
      ? interestTags[tagLang] || interestTags['en']
      : interestTags['en'],
    loading,
    findTagItem,
  };
};

export default useInterestTags;
